import {React, Fragment, useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// ICONS
import { MenuIcon, XIcon } from "@heroicons/react/outline";
// PAGES
import DevicesPage from "./DevicesPage";
import { SidebarDesktop } from "../../../components/sidebar/SidebarDesktop";
import { SidebarMobile } from "../../../components/sidebar/SidebarMobile";
import { API_ENDPOINTS } from "../../../config/api";

export default function DevicesLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [devices, setDevices] = useState([{}]);
  const navigate = useNavigate();

  useEffect(() => {
    let { token } = JSON.parse(localStorage.getItem('BACK_API')) || {};
    
    if (!token) {
      navigate('/auth/login')
    } else {
      axios.get(
        API_ENDPOINTS.GET_DEVICES,
        // { headers: {authorization: `bearer ${token}`}}
      ).then((respuesta) => {
        setDevices(respuesta.data);
      }).catch((error) => {
        // console.log('error:', error)
        navigate('/auth/login')
      });
    }
  }, [navigate])

  return (
    <div>
      <div>
        {/* SIDEBAR ANIMATIONS FOR OPENING AND CLOSING */}
        <Transition.Root show={sidebarOpen} as={Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 flex z-40 md:hidden"
            onClose={setSidebarOpen}
          >
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-600 bg-opacity-75" />
            </Transition.Child>
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <div className="relative flex-1 flex flex-col max-w-xs w-full bg-white">
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-300"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="absolute top-0 right-0 -mr-12 pt-2">
                    <button
                      type="button"
                      className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                      onClick={() => setSidebarOpen(false)}
                    >
                      <span className="sr-only">Close sidebar</span>
                      <XIcon
                        className="h-6 w-6 text-white"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </Transition.Child>
                
                {/* MOBILE SIDEBAR */}
                <SidebarMobile devices={devices}/>
              </div>
            </Transition.Child>
            <div className="flex-shrink-0 w-14">
              {/* SHRINK SIDEBAR */}
            </div>
          </Dialog>
        </Transition.Root>

        {/* DESKTOP SIDEBAR*/}
        <SidebarDesktop titleSidebar="Select a device" devices={devices}/>

        {/* MOBILE SIDEBAR BAR */}
        <div className="md:pl-80 flex flex-col flex-1 overflow-auto h-navbar">
          <div className="sticky top-0 z-10 md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3 bg-white">
            <button
              type="button"
              className="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
              onClick={() => setSidebarOpen(true)}
            >
              <span className="sr-only">Open sidebar</span>
              <MenuIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          {/* PAGE CONTENT */}
          <main className="flex-1 h-navbar ">
            <DevicesPage />
          </main>
        </div>
      </div>
    </div>
  );
}
